module.exports = __webpack_public_path__ + "static/media/sf-test-17.f0c50d08.mp3";